import { render } from "./ModulosGestion.vue?vue&type=template&id=fd052bcc"
import script from "./ModulosGestion.vue?vue&type=script&lang=js"
export * from "./ModulosGestion.vue?vue&type=script&lang=js"

import "./ModulosGestion.vue?vue&type=style&index=0&id=fd052bcc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__